import { ZyExerciseIcon } from '@/components/tiptap-editor/tiptap-icons/zyexercise-icon';
import { isSelectionTopNode } from '@/lib/zy-tiptap-utils';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

const ZyExerciseButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyExercise"
        extensionType="node"
        icon={ZyExerciseIcon}
        isDisabled={editor => !isSelectionTopNode(editor)}
        label="Insert zyExercise"
        command={editor => editor.commands.insertZyExercise()}
        ref={ref}
        {...props}
    />
));

ZyExerciseButton.displayName = 'ZyExerciseButton';

export default ZyExerciseButton;
